import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ShowHideInput, UserService } from '../shared';
import { SucesstempComponent } from '../sucesstemp/sucesstemp.component';
import { TranslateService } from '@ngx-translate/core';
 
@Component({
  selector: 'app-resetpass',
  templateUrl: './resetpass.component.html',
  styleUrls: ['./resetpass.component.css']
})
export class ResetpassComponent implements OnInit {
  myDiv: any;
  openErroModel: any;
  modalRef: BsModalRef;
  @ViewChild(ShowHideInput) input: ShowHideInput;
  @ViewChild('erroModal') erroModal: ElementRef;
  respass: string;
  show = false;
  isSubmitting = false;
  public params: any;
  public pasd: any = {};
  newonepassword = '';
  newtwopassword = '';
  errormsgpass = '';
  @ViewChild('popvaild') testModal: TemplateRef<any>;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    private activeroute: ActivatedRoute,
    private routers: Router,
    private userservic: UserService,
    private modalService: BsModalService,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang(userservic.defaultLang);
  }

  ngOnInit() {



    this.userservic.getresetpass(window.localStorage['randId'])
      .subscribe(
        data => {

          if (data.item.status == "success") {
            this.userservic.logAudit("updatePasswordForForgotPassword", 0).subscribe(data => { })

          } else {

            // ////console.log("hello")

          }
        })
  }

  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    }
    else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }
  openModalc(passcha) {
    //////console.log(passcha);
    this.modalRef = this.modalService.show(passcha, { class: 'modal-sm', backdrop: 'static' })
  }



  password(ed) {
    // ////console.log('Valuessss:' , ed.value)
    if (ed.value.newonepassword == ed.value.newtwopassword) {

      let pass = {
        "userAccountId": window.localStorage['randId'],
        "newPwd": ed.value.newonepassword,
        "confirmPassword": ed.value.newtwopassword
      }
      // ////console.log(pass)
      this.userservic.getresetpass(pass)
        .subscribe(
          data => {
            if (data.item.status == "success") {
              // ////console.log('Successfully Passsword Updated');        
              this.userservic.logAudit("updatePasswordForForgotPassword", 0).subscribe(data => { })
              this.dialog.open(SucesstempComponent, { hasBackdrop: false });
              this.errormsgpass = '';

            } else {
              this.errormsgpass = data.item.message;


            }
          })

    }
    else {
      this.errormsgpass = 'New Password Not Match';

    }
  }
  getFullYear() {
    return new Date().getFullYear();
  }
}
